module.exports = __webpack_public_path__ + "public/Icons/availableIcon.svg?a64329ac";